import React from 'react';
import createUtmParameters from 'components/Dashboard/helpers/createUtmParameters';
import useIsMobile from 'components/Dashboard/utilities/useIsMobile';
import { useLocation } from 'react-router';
import getAppSite from 'utils/getAppSite';

const LoginButtons = () => {
  const isMobile = useIsMobile();
  const location = useLocation();
  return (
    <div className='d-flex justify-content-lg-end login-buttons'>
      <>
        {(isMobile || getAppSite() === 'usa') && (
          <button
            className={
              getAppSite() === 'usa'
                ? 'text-main-blue border-general border-main-blue-60 rounded-pill px-4 specific-top-padding-3 specific-bottom-padding-5 mr-3 btn-login-home login-us-btn'
                : 'btn btn-default btn-login pr-xl-4 pl-0 pl-lg-2'
            }
            onClick={() => {
              window.location.assign(
                `/login?returnUrl=${encodeURIComponent(`${location.pathname}${location.search}${location.hash}`)}`
              );
            }}
          >
            Log in
          </button>
        )}
        <button
          className={`btn btn-default btn-register px-3 px-xl-3 text-white`}
          onClick={() => {
            window.location.assign(`/register?reg_source=topnav-start-free-trial-button${createUtmParameters('&')}`);
          }}
        >
          Start free trial
        </button>
      </>
    </div>
  );
};

export default LoginButtons;
